import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {client} from '../../Client';

class LogoutButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
      let user = client.getCurrentUser();
      let imgProfilo = "generic-user-profile.jpg";
      if (user.imgprofilo){
        imgProfilo = user.username+".jpg";
      }
    return (        
      <div className="item">
          <div className="content">
            <img id="imgprofile" alt="Immagine del profilo" width={"50"} style={{margin: "-10px 5px -14px 0"}} src={client.getApiBaseUrl()+"/images/"+imgProfilo}></img>
          </div>
          <div className="content">Utente collegato: <Link to={`/app/profiloutente/edit/${user.idUtente}`}>
            <h3>{user.nome} - {user.email}</h3></Link>
          </div>
        <Link className='icon active item' to='/logout' style={{display:'flex', paddingTop: '0', paddingBottom: '0'}}>
          <h3><i className="sign out icon" /> <br/>Esci</h3>
        </Link>

      </div>
)
  }
}

export default LogoutButton;




/** WEBPACK FOOTER **
 ** ./src/components/main/LogoutButton.js
 **/